import React, { useState } from "react";
import PersonAddDisabledIcon from "@mui/icons-material/PersonAddDisabled";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { ConfirmDialog } from "../../../../components/ui";
import { IAccountGroup } from "../../../../api/fundedCompliance/index.types";
import { FUNDED_COMPLIANCE_API_URLS, FundedComplianceAPI } from "../../../../api/fundedCompliance";

interface IProps {
  account: IAccountGroup["compliance_traders_accounts"][number];
}

const DeleteFromGroup: React.FC<IProps> = ({ account }) => {
  const [open, setOpen] = useState(false);
  const queryClient = useQueryClient();
  const handleClickOk = useMutation({
    mutationFn: () => FundedComplianceAPI.deleteFromGroupRequest(account.id),
    onSuccess: () => {
      setOpen(false);
      queryClient.invalidateQueries({
        queryKey: [FUNDED_COMPLIANCE_API_URLS.tradersDbList, "tradersDbList"],
      });
    },
    onError: () => {
      setOpen(false);
    },
  });

  const accountEmail = account?.account?.email || account?.submissions_outer_account?.email;

  return (
    <div>
      <ConfirmDialog
        isOpen={open}
        dialogTitle="Remove account from trader"
        dialogContentText={
          <span>
            Are you sure you want to remove <b>{accountEmail}</b> from the trader?
          </span>
        }
        handleCancel={() => setOpen(false)}
        handleClickOk={() => handleClickOk.mutate()}
      />
      <PersonAddDisabledIcon
        onClick={() => setOpen(true)}
        color="secondary"
        fontSize="small"
        sx={{ ml: "10px", cursor: "pointer" }}
      />
    </div>
  );
};

export default DeleteFromGroup;
